import {
  Button,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Radio,
  Select,
  Typography,
} from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { translation } from "../../../i18n/translationConstant";
import CommonModal from "../../Common/Components/CommonModal";
import AddIdentifierImage from "../../../Assets/add_identifier.png";
import OTPInputComponent from "../../Common/Components/OTPModal";
import "../index.css";
import {
  IdentifierCategory,
  IdentifierType,
  StrongIdentifier,
} from "../../../Utils/Constants/identifierType";
import {
  validAadhar,
  validAccNo,
  validEmail,
  validMobile,
  validPan,
} from "../../../Utils/Constants/identifierValidator";
import { CalendarOutlined } from "@ant-design/icons";
import { EntityIdentifier } from "../../../Models/Request/Identifier/EntityIdentifier";

interface IAddUserIdentificationProps extends React.PropsWithChildren {
  visible: boolean;
  handleCancel: () => void;
  identifierEntered: (otp: any) => void;
  isAddIdentifierVerification: boolean;
  onOTPSubmit: (otp: string, identifierNumber: any) => void;
  label: string;
  form?: FormInstance<any>;
  multipleIdentifiers: boolean;
  mobileNumber?: string;
  isForgotPassword: boolean;
  entityIdentifiers: EntityIdentifier[];
}

const UserIdentification: React.FC<IAddUserIdentificationProps> = ({
  visible,
  handleCancel,
  identifierEntered,
  isAddIdentifierVerification,
  onOTPSubmit,
  children,
  label,
  form,
  multipleIdentifiers,
  mobileNumber,
  isForgotPassword,
  entityIdentifiers,
}) => {
  const [t] = useTranslation();
  const [identifierCategory, setIdentifierCategory] = useState(
    IdentifierCategory.STRONG
  );
  const [selectedIdentifierType, setSelectedIdentifierType] =
    useState("MOBILE");
  const [identifierObject, setIdentifierObject] = useState({
    categoryType: "",
    type: "",
    value: "",
  });
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );

  const onOTPValueSubmit = (otp: string) => {
    onOTPSubmit(
      otp,
      isForgotPassword ? identifierObject.value : identifierObject
    );
  };

  const onCancel = () => {
    handleCancel();
    setIdentifierObject({ categoryType: "", type: "", value: "" });
    setSelectedIdentifierType("");
    form?.resetFields();
  };

  const onIdentifierEntered = () => {
    identifierEntered(form?.getFieldValue("value"));
  };
  const onIdentifierTypeChange = (value: any) => {
    
    setSelectedIdentifierType(value);
    const selectedItem = entityIdentifiers.find(
      (item: EntityIdentifier) => item.type === value
    );
    const category = selectedItem?.category?.toUpperCase() as IdentifierCategory;
    // const category =
    //   selectedItem?.category.toUpperCase() === IdentifierCategory.STRONG
    //     ? IdentifierCategory.STRONG
    //     : IdentifierCategory.WEAK;
    setIdentifierCategory(category);
    form?.resetFields(["value"]);
  };
  const customValidator = (_: any, value: string) => {
    if (value) {
      switch (selectedIdentifierType) {
        case StrongIdentifier.MOBILE: {
          if (!validMobile.test(value)) {
            return Promise.reject(
              new Error(t(translation.errorInvalidPhoneNumber))
            );
          }
          break;
        }
        case IdentifierType.AADHAR: {
          if (!validAadhar.test(value)) {
            return Promise.reject(
              new Error(t(translation.errorEnterValidAadhaar))
            );
          }
          break;
        }
        case IdentifierType.PAN: {
          if (!validPan.test(value)) {
            return Promise.reject(new Error(t(translation.errorEnterValidPan)));
          }
          break;
        }
        case IdentifierType.EMAIL: {
          if (!validEmail.test(value)) {
            return Promise.reject(
              new Error(t(translation.errorEnterValidEmail))
            );
          }
          break;
        }
        case IdentifierType.ACCNO: {
          if (!validAccNo.test(value)) {
            return Promise.reject(
              new Error(t(translation.errorEnterValidAccountNumber))
            );
          }
          break;
        }
        case IdentifierType.DOB: {
          const dobRegex = /^\d{2}\/\d{2}\/\d{4}$/;

          if (!dobRegex.test(value)) {
            return Promise.reject(
              new Error(t(translation.errorInvalidDateFormat))
            );
          }

          const [day, month, year] = value.split("/").map(Number);
          const date = new Date(year, month - 1, day);

          if (
            date.getFullYear() !== year ||
            date.getMonth() !== month - 1 ||
            date.getDate() !== day
          ) {
            return Promise.reject(
              new Error(t(translation.errorInvalidDate))
            );
          }

          break;
        }
      }
    }
    return Promise.resolve();
  };
  const disabledDate = (current: any) => {
    return current && current.valueOf() > Date.now();
  };

  console.log("entityIdentifiers", entityIdentifiers);
  return (
    <>
      {isAddIdentifierVerification ? (
        <>
          <OTPInputComponent
            title={t(translation.lblVerify)}
            isOpen={visible}
            onOtpSubmit={onOTPValueSubmit}
            onCancel={onCancel}
            okText={t(translation.lblConfirm)}
            onResend={onIdentifierEntered}
            mobileNumber={
              isForgotPassword ? mobileNumber : form?.getFieldValue("value")
            }
          />
        </>
      ) : (
        <>
          <CommonModal visible={visible} onCancel={onCancel}>
            <div className="col alignCenter">
              {isForgotPassword ? (
                <>
                  <Typography.Text className="font24 fontWeight600 marginTop10">
                    {t("lblForgotPassword")}
                  </Typography.Text>
                </>
              ) : (
                <>
                  <img
                    src={AddIdentifierImage}
                    className="marginTop20"
                    alt={t("lblAddIdentifier")}
                    style={{ height: 100, width: 100 }}
                  />
                  <Typography.Text className="font24 fontWeight600 marginTop10">
                    {t("lblAddIdentifier")}
                  </Typography.Text>
                </>
              )}
              {
                <Form
                  form={form}
                  className="marginTop50 width90"
                  // tslint:disable-next-line: jsx-no-lambda
                  onFinish={(values) => {
                    let data = {
                      categoryType: identifierCategory,
                      value: values["value"],
                      type: values["type"],
                    };
                    identifierEntered(data);
                    console.log(data);
                    setIdentifierObject(data);
                  }}
                  onFieldsChange={() => {
                    /*  if (
                      form?.getFieldValue("categoryType") !== identifierCategory
                    ) {
                      setIdentifierCategory(
                        form?.getFieldValue("categoryType")
                      );

                      form?.resetFields(["type", "value"]);
                    } */
                  }}
                  // tslint:disable-next-line: jsx-no-lambda
                >
                  {!isForgotPassword ? (
                    <>
                      {/* <Typography.Text>
                        {t(translation.lblCategoryType)}
                      </Typography.Text> */}
                      {/* <Form.Item
                        name="categoryType"
                        rules={[
                          {
                            required: true,
                            message: "* Required field",
                          },
                        ]}
                        initialValue={IdentifierCategory.STRONG}
                      >
                        <Radio.Group className="identifierRadioGroup">
                          <Radio value={IdentifierCategory.STRONG}>
                            {IdentifierCategory.STRONG}
                          </Radio>
                          <Radio value={IdentifierCategory.WEAK}>
                            {IdentifierCategory.WEAK}
                          </Radio>
                          <Radio value={IdentifierCategory.ANCILLARY}>
                            {IdentifierCategory.ANCILLARY}
                          </Radio>
                        </Radio.Group>
                      </Form.Item> */}
                      <Typography.Text>
                        {t(translation.lblIdentifierType)}
                      </Typography.Text>
                      <Form.Item
                        name="type"
                        rules={[
                          {
                            required: true,
                            message: "Please select type of Identifier!",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Please select type of Identifier"
                          className="identifierTypeSelector"
                          onChange={onIdentifierTypeChange}
                          bordered={false}
                        >
                          {/* {identifierCategory === IdentifierCategory.STRONG
                            ? Object.keys(StrongIdentifier).map(
                                (identifier1, index) => (
                                  <Select.Option
                                    key={index}
                                    value={identifier1}
                                  >
                                    {identifier1}
                                  </Select.Option>
                                )
                              )
                            : Object.keys(IdentifierType).map(
                                (identifier1, index) => (
                                  <Select.Option
                                    key={index}
                                    value={identifier1}
                                  >
                                    {identifier1}
                                  </Select.Option>
                                )
                              )} */}
                          {entityIdentifiers.length > 0 &&
                            entityIdentifiers.map((identifier1, index) => (
                              <Select.Option
                                key={index}
                                value={identifier1.type}
                              >
                                {identifier1.type}
                              </Select.Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </>
                  ) : (
                    <></>
                  )}
                  <Typography.Text>
                    {isForgotPassword
                      ? t(translation.lblMobileNumber)
                      : t(translation.lblIdentifierValue)}
                  </Typography.Text>
                  <Form.Item
                    rules={[
                      {
                        required: true,
                        message: t(translation.errorRequiredvalue),
                      },
                      {
                        validator: customValidator,
                      },
                    ]}
                    name="value"
                  >
                    {selectedIdentifierType === IdentifierType.DOB ? (
                      <div className="dob">
                        <DatePicker
                          disabledDate={disabledDate}
                          popupClassName="dobPicker"
                          onChange={(_, dateString: string) =>
                            form?.setFieldValue("value", dateString)
                          }
                          format={"DD/MM/YYYY"}
                          name="value"
                          suffixIcon={<CalendarOutlined onPointerOverCapture={undefined} onPointerMoveCapture={undefined}/>}
                          showToday={false}
                        />
                      </div>
                    ) : (
                      <Input
                        className="inputNumber marginTop8"
                        maxLength={isForgotPassword ? 10 : undefined}
                        placeholder={
                          isForgotPassword
                            ? t(translation.lblMobileNumber)
                            : t(translation.lblEnterIdentifierValue)
                        }
                      />
                    )}
                  </Form.Item>
                  <div className="row spaceEvenly width100">
                    <Form.Item>
                      <Button
                        onClick={onCancel}
                        className="font16 fontWeight600 cancelButton"
                        htmlType="button"
                      >
                        {t(translation.lblCancel)}
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        htmlType="submit"
                        type="primary"
                        className="font16 fontWeight600 confirmButton"
                        loading={loading}
                      >
                        {t(translation.lblConfirm)}
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              }
            </div>
          </CommonModal>
        </>
      )}
    </>
  );
};
export default UserIdentification;
